import {Locale} from '@hebcal/hdate';
import poData from './fi.po.js';
Locale.addLocale('fi', poData);
